/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types';

// components
import Typography from '@mui/material/Typography'

function InputLabel({ label, styles }) {
  return (
    <Typography
      variant="h6"
      gutterBottom
      style={{
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '140%',
              fontFamily: 'Johnson Text',
              ...styles
            }}
    >
      {label}
    </Typography>
  )
}

InputLabel.propTypes = {
  styles: PropTypes.object,
};

InputLabel.defaultProps = {
  styles: { }
};

export default InputLabel
